import apis from "../../core/apis.js";

class LoanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.loan).get(options);
  }

  get(id) {
    return this.$resource(apis.loan + id).get();
  }

  post(item) {
    return this.$resource(apis.loan).save(item);
  }

  finalize(id, item) {
    return this.$resource(apis.loan + id + "/finalize").save(item);
  }
}

export default LoanResource;



// WEBPACK FOOTER //
// ./src/resources/loan/loan.resource.js